<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading" style="height: 100%;">

  


<gridster  [options]="options" >
    <gridster-item [item]="item" *ngFor="let item of dashboard">
        <div class="product-item">
            <div class="product-item-content">
                <div fxLayout="row" fxLayoutGap="16px">
                    <div fxFlex="50">
                        <div class="mb-3">
                            <!-- <img src="data:image/jpeg;base64,{{artikel.bildKlein}}" *ngIf="artikel.bildKlein != null" style="max-height: 50px;"/>
                            <img src="{{imgDummy}}" *ngIf="artikel.bildKlein == null" style="max-height: 25%; max-width: 25%" /> -->
                        </div>
                        <div class="mt-4">
                            Art. Nr. 
                        </div>
                        <div>
                            Hersteller Nr. 
                        </div>
    
                    </div>
                    <div fxFlex="50">
                        <div>
                            <h4 class="mb-1">{{item.name}}</h4>
                           
                        </div>
                    </div>
                </div>
                <div fxLayout="row" class="button-holder">
                    <div fxFlex="100">
                        <div class="mt-4">
                            <button mat-mini-fab color="warn">
                                <mat-icon class="matIcon-md mt-1">search</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </gridster-item>
  </gridster>


</div>
